import React from 'react';
import { RouteContext } from '../App';
import FolderView from './FolderView';
import HomeView from './HomeView';
import ImageView from './ImageView';
import MessageView from './MessageView';

const PageTypeLoader = () => {
    return (
        <RouteContext.Consumer>
            {(ctx) => {
                const pageType = ctx.pageType ? ctx.pageType.toLowerCase() : "";
                switch (pageType) {
                    case "folder": {
                        return <FolderView folderId={ctx.id} />
                    }
                    case "image": {
                        return <ImageView imageId={ctx.id} />
                    }
                    case "home": {
                        return <HomeView />
                    }
                    default: {
                        return <MessageView>Unknown page type {ctx.pageType}</MessageView>
                    }
                }
            }}
        </RouteContext.Consumer>
    )
}

export default PageTypeLoader;